<template>
  <div class="ProgressBar">
    <table id="progressBar">
      <tr>
        <td
          :style="
            isActive(`ProductDetails`)
              ? 'background-color: #da6f38; font-weight: bold;'
              : 'background-color: #001538; font-weight: 300;'
          "
        >
          {{ $mlGet("progressBar-ModelDetails") }}
          <i class="fa fa-arrow-right whiteColor" />
        </td>
        <td class="divider"><span></span></td>
        <td
          v-if="$store.state.user.hasDealerSpecialOptions"
          :style="
            isActive(`DealerOptions`)
              ? 'background-color: #da6f38; font-weight: bold;'
              : 'background-color: #001538; font-weight: 300;'
          "
        >
          {{ $mlGet("progressBar-dealerSpecialOptions") }}
          <i class="fa fa-arrow-right whiteColor" />
        </td>
        <td v-if="$store.state.user.hasDealerSpecialOptions" class="divider">
          <span></span>
        </td>
        <td
          :style="
            isActive(`WarrantyInformation`)
              ? 'background-color: #da6f38; font-weight: bold;'
              : 'background-color: #001538; font-weight: 300;'
          "
        >
          {{ $mlGet("progressBar-WarrantyInformation") }}
          <i class="fa fa-arrow-right whiteColor" />
        </td>
        <td class="divider"><span></span></td>
        <td
          :style="
            isActive(`ProblemDescription`)
              ? 'background-color: #da6f38; font-weight: bold;'
              : 'background-color: #001538; font-weight: 300;'
          "
        >
          {{ $mlGet("progressBar-ProblemDescription") }}
          <i class="fa fa-arrow-right whiteColor" />
        </td>
        <td class="divider"><span></span></td>
        <td
          :style="
            isActive(`TransportOptions`)
              ? 'background-color: #da6f38; font-weight: bold;'
              : 'background-color: #001538; font-weight: 300;'
          "
        >
          {{ $mlGet("progressBar-Transport") }}
          <i class="fa fa-arrow-right whiteColor" />
        </td>
        <td class="divider"><span></span></td>
        <td
          :style="
            isActive(`ConfirmationOptions`)
              ? 'background-color: #da6f38; font-weight: bold;'
              : 'background-color: #001538; font-weight: 300;'
          "
        >
          {{ $mlGet("progressBar-Confirm") }}
          <i class="fa fa-arrow-right whiteColor" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgressBar extends Vue {
  @Prop() public currentGroupName!: string;

  isActive(groupName: string) {
    return this.currentGroupName === groupName;
  }
}
</script>

<style scoped>
#progressBar {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  border: 1px solid lightgray;
  background-color: #001538;
  color: white;
  background-color: #001538;
}

#progressBar tr {
  padding: 10px;
  margin: 0;
}

#progressBar tr td {
  padding: 12px 6px;
  text-align: center;
  width: 100%;
  font-family: "Overpass", sans-serif !important;
}

.divider {
  width: 4px !important;
  padding: 2px !important;
  margin: 0 !important;
  height: 10px;
  background-color: #001538;
}

.divider span {
  display: block;
  background-color: white;
  width: 2px;
  height: 40px;
}

.whiteColor {
  color: white;
}
</style>
